import { ChevronRight } from 'lucide-react';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import i18n from '@/settings/i18n';
import { useProductPageContext } from '@/components/v2/product/hooks/useProductPageContext';
import SpecificationList from './SpecificationList';

const t = i18n.init('product');

const SpecificationsSlider = dynamic(() => import('./SpecificationsSlider'), {
  ssr: false,
});

const Specifications = () => {
  const { product } = useProductPageContext();
  const [showModal, setShowModal] = useState(false);

  // Specifications
  const specifications = product?.specifications ?? [];

  // Don't render if no specifications
  if (specifications.length === 0) {
    return null;
  }

  return (
    <>
      <button
        className="flex w-full items-center justify-between border-b p-4 text-left font-medium hover:underline focus:outline-none"
        onClick={() => {
          setShowModal(!showModal);
        }}
      >
        <h2>{t`Specifications`}</h2>
        <ChevronRight className="h-5 w-5 shrink-0" />
      </button>
      {/* The slider only renders in the browser, so crawlers that don't run JS
          would see no specs. A hidden copy keeps them in the server HTML (RT-17690). */}
      <SpecificationList specifications={specifications} hidden />
      <SpecificationsSlider showModal={showModal} setShowModal={setShowModal} />
    </>
  );
};

export default Specifications;
